// スナップ (純ロジック)。候補線 (ガイド・文書端・グリッド) に対して矩形の辺と中心を吸着させる。
import type { Rect } from '@/types/geometry'

export interface SnapTargets {
  xs: number[]
  ys: number[]
}

export function snapTargets(docW: number, docH: number, guides: { axis: 'x' | 'y'; position: number }[], grid: number | null): SnapTargets {
  const xs = [0, docW, docW / 2], ys = [0, docH, docH / 2]
  for (const g of guides) (g.axis === 'x' ? xs : ys).push(g.position)
  if (grid && grid > 0) {
    for (let x = 0; x <= docW; x += grid) xs.push(x)
    for (let y = 0; y <= docH; y += grid) ys.push(y)
  }
  return { xs, ys }
}

/** rect の左/中/右 (上/中/下) が候補に吸着するときの移動量。しきい値 (px) 内に無ければ 0 */
export function snapDelta(rect: Rect, targets: SnapTargets, threshold: number): { dx: number; dy: number } {
  const pick = (edges: number[], lines: number[]) => {
    let best = 0, bestD = threshold + 1e-9
    for (const e of edges) for (const l of lines) {
      const d = l - e
      if (Math.abs(d) < Math.abs(bestD)) { bestD = d; best = d }
    }
    return Math.abs(bestD) <= threshold ? best : 0
  }
  return { dx: pick([rect.x, rect.x + rect.w / 2, rect.x + rect.w], targets.xs), dy: pick([rect.y, rect.y + rect.h / 2, rect.y + rect.h], targets.ys) }
}
